<template>
  <nuxt-link
    id="like-btn"
    text
    class="favorites-jobs-btn d-block"
    :title="title"
    :to="'/myjobs.aspx'"
    :prefetch="false"
  >
    <span v-if="jobsBasketSum > 0" class="like-sum">{{ jobsBasketSum }}</span>
    <img src="@/assets/23/heart.svg" class="like-sum-icon" />
    <!-- <span class="like-sum-text">מודעות שאהבתי</span> -->
  </nuxt-link>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'משרות שאהבתי',
    };
  },

  computed: {
    ...mapState({ jobsBasket: (state) => state.authUser.jobsBasket }),
    ...mapGetters(['JobBasket', 'isLogged']),

    jobsBasketSum() {
      /**
       * Number of jobs IN THE BASKET
       */
      if (this.isLogged) {
        return this.JobBasket.length;
      }

      return this.jobsBasket.size || 0;
    },
  },
  watch: {
    jobsBasket() {
      this.$cookies.set('drushimJobs', Array.from(this.jobsBasket).toString(), {
        path: '/',
      });
    },
  },
  methods: {
    goToMyJobs() {
      if (!_.isEmpty(this.jobsBasket)) {
        this.$router.push({
          path: '/myJobs.aspx',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.like-sum-text {
  display: inline-flex;
  padding-right: 2px;
}
#like-btn {
  padding: 0;
  position: relative;
  text-decoration: none;
  // width: 130px;
  font-size: 15px;
  color: #363636;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: right;
}
#like-btn .like-sum-icon {
  vertical-align: middle;
}

#like-btn .like-sum {
  position: absolute;
  right: -13px;
  bottom: 10px;
  display: flex;
  width: 20px;
  height: 20px;
  font-weight: normal;
  padding: 1px 1px 0 0;
  font-size: 11px;
  line-height: 22px;
  text-align: center;
  background-color: #ff7100;
  border: 2px solid white;
  border-radius: 50%;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  color: white;
}

@media screen and (max-width: 1560px) {
  #like-btn .like-sum-text {
    display: none !important;
  }
  #like-btn {
    width: auto;
    margin: 0 15px 0 5px;
  }
}
@media screen and (max-width: 968px) {
  #like-btn {
    width: auto;
    margin: 0 11px 0 5px;
  }
  // #like-btn .like-sum-text {
  //   display: none !important;
  // }
  #like-btn .like-sum {
    position: absolute;
    right: -10px;
    bottom: 4px;
    display: block;
    width: 20px;
    height: 20px;
    font-size: 9px;
    line-height: 18px;
    text-align: center;
    background-color: #ff7100;
    border: 2px solid #fff;
    border-radius: 50%;
  }
}
@media screen and (max-width: 600px) {
  #like-btn .like-sum {
    line-height: 16px;
  }
}
</style>
